var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"he-setting-item-box"},[_c('el-form',{attrs:{"label-position":"right","label-width":"140px","size":"small","model":_vm.model}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }